var render = function render(){var _vm=this,_c=_vm._self._c;return _c('g',{attrs:{"id":"Check/SelectedDark","stroke":"none","stroke-width":"1","fill":"none","fill-rule":"evenodd"}},[_c('rect',{attrs:{"id":"Rectangle","fill":"#DADCE0","x":"0","y":"0","width":"18","height":"18","rx":"2"}}),_c('rect',{attrs:{"id":"Rectangle","fill":"#07CE6F","x":"4","y":"4","width":"10","height":"10","rx":"1"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }